<template lang="html">
  <div>
    <van-loading size="24px" vertical style="padding-top:50%;">
      登录中...
    </van-loading>
  </div>
</template>

<script>
  import qs from "qs"
  import store from '../store/index'
  import Vue from 'vue'
  import VueLocalStorage from 'vue-localstorage'
  import { Loading } from 'vant'
  Vue.use(VueLocalStorage)
  Vue.use(Loading)

  export default {
    data () {
      return {
        url: '',
        scope: 'snsapi_userinfo'
      }
    },
    methods: {
      auth () {
        let code = qs.parse(
          window.location.href.split('?')[1])['code']
        if (code) {
          window.console.log(code)
          let params = {
            url: this.url,
            scope: this.scope,
            code: code
          }
          let that = this
          this.$api.libs.userInfo(params).then(res => {
            window.console.log("获取到UserInfo的Response是：")
            window.console.log(res)
            let plainAccessToken = false
            that.authSuccess(res, plainAccessToken)
          })
        } else {
          let params = {
            url: this.url,
            scope: this.scope
          }
          this.$api.libs.authorizeUrl(params).then(res => {
            window.location.replace(res.data.authorize_url)
          })
        }
      },
      authSuccess (res, plainAccessToken) {
        // let redirect = store.state.auth.redirect
        let redirect = Vue.localStorage.get('redirect', null)
        window.console.log(`成功后跳转回：${redirect}`)
        window.console.log(res)
        if (plainAccessToken) {
          let wechatAccessToken = JSON.parse(
            Vue.localStorage.get('wechatAccessToken'))
          wechatAccessToken.access_token = res.data.access_token
          Vue.localStorage.set(
            'wechatAccessToken',
            JSON.stringify(wechatAccessToken))
        } else {
          Vue.localStorage.set(
            'wechatAccessToken',
            JSON.stringify(res.data.access_token))
        }
        Vue.localStorage.set(
          'wechatUserInfo',
          JSON.stringify(res.data.user_info))
        store.commit('setToken', res.data.jwt_token)
        // 把token和expire存入LocalStorage
        window.console.log("运行到这里 444")
        Vue.localStorage.set('token', res.data.jwt_token)
        Vue.localStorage.set(
          'expire', new Date().getTime() + 1800 * 1000 * 5)
        // Vue.localStorage.set(
        //   'expire', new Date().getTime() + 1 * 10 * 1000)
        Vue.localStorage.set('uid', res.data.uid)
        store.commit('setUid', res.data.uid)
        store.commit('authProcessing', false)
        window.console.log("准备跳转...")
        window.console.log(`redirect: ${redirect}`)
        if (redirect) {
          window.console.log("准备跳转...1")
          window.console.log(redirect)
          this.$router.replace(redirect)
          location.reload()
        }
      },
      updateUserInfo (url, scope, access_token) {
        // 通过 access_token 调用后端接口，获取user_info（并更新），再获取jwt_token
        let params = {
          url: this.url,
          scope: this.scope,
          openid: access_token.openid,
          access_token: access_token.access_token}
        let that = this
        this.$api.libs.updateUserInfo(params).then(res => {
          window.console.log("用户信息已更新")
          window.console.log(res)
          const plainAccessToken = true
          that.authSuccess(res, plainAccessToken)
        })
      },
    },
    created () {
      let that = this
      that.url = window.location.href
      let access_token = JSON.parse(
        Vue.localStorage.get('wechatAccessToken', null))
      window.console.log(access_token)
      if (access_token) {
        window.console.log("有微信的access_token")
        let params = {
          url: that.url,
          scope: that.scope,
          openid: access_token.openid,
          access_token: access_token.access_token}
        window.console.log("运行到这里...1")
        that.$api.libs.checkAccessToken(params).then(res => {
          let valid = res.data.valid
          window.console.log("运行到这里...2")
          window.console.log(res)
          if (valid) {
            window.console.log("微信的access_token还有效")
            that.updateUserInfo (that.url, that.scope, access_token)
          } else {
            window.console.log("微信的access_token已过期")
            let params = {
              url: that.url,
              scope: that.scope,
              refresh_token: access_token.refresh_token}
            that.$api.libs.refreshAccessToken(params).then(res => {
              window.console.log("AccessToken已刷新：")
              window.console.log(res)
              access_token = res.data
              Vue.localStorage.set(
                'wechatAccessToken',
                JSON.stringify(access_token))
              that.updateUserInfo (this.url, this.scope, access_token)
            })
            .catch(error => {
              // 清除本地存储里的 accesstoken和userinfo
              window.console.log("刷新AccessToken出错：")
              window.console.log(error)
              Vue.localStorage.remove('wechatAccessToken')
              that.auth()
            })
          }
        })
        .catch(error => {
          window.console.log("运行到这里... 1.1")
          window.console.log(error)
        })
      } else {
        that.auth()
      }
    }
  }
</script>

<style lang="css" scoped>
</style>
